import { useState } from 'react';
import { FieldName, PolicyFormValues } from '../types/forms';
import { getFormFieldsErrors, getMissingFields, getPolicyFromValuesFromTemplate } from '../utils/forms';
import { PolicyTemplate } from '../../../../types/policies';
import { PolicyConfiguration } from '../../types/PolicyConfiguration';

export const usePolicyForm = (template: PolicyTemplate, policyConfiguration: PolicyConfiguration) => {
    const [policyFormValues, setPolicyFormValues] = useState<PolicyFormValues>(
        getPolicyFromValuesFromTemplate(template)
    );

    const hasMissingFields = getMissingFields(template, policyFormValues).length > 0;
    const fieldErrors = getFormFieldsErrors(policyFormValues, policyConfiguration);
    const hasFieldErrors = Object.keys(fieldErrors).length > 0;
    const formValid = !hasMissingFields && !hasFieldErrors;

    const setPolicyFormValue = <K extends FieldName>(fieldName: K, value: PolicyFormValues[K]) => {
        setPolicyFormValues((prevPolicyFormValues) => ({
            ...prevPolicyFormValues,
            [fieldName]: value
        }));
    };

    return {
        policyFormValues,
        fieldErrors,
        formValid,
        setPolicyFormValue
    };
};
